import React, { Component } from 'react';
import {withRouter} from 'react-router';


class NotFound extends Component {

  render() {
    return (
      <div>
        <h1>Not Found</h1>
      </div>
    );
  }
}

export default withRouter(NotFound);


// WEBPACK FOOTER //
// ./src/app/components/notFound.js